import React, { useState, useEffect, useCallback } from "react";
import { CONSTANT } from './constants';
import axios from "axios";

const CaptchaInput = ({
    value,
    onChange,
    onCaptchaChange,
    error,
    refreshTrigger = 0,
    label = 'Verification',
    placeholder = 'Enter answer',
}) => {
    const [question, setQuestion] = useState('');
    const [loading, setLoading] = useState(false);
    const [captchaMeta, setCaptchaMeta] = useState({ token: '', expires_at: 0 });

    const loadCaptcha = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${CONSTANT.BASE_URL}api/Builder/createCaptcha`);
            if (response.data.success) {
                const { question: q, token, expires_at } = response.data;
                setQuestion(q);
                setCaptchaMeta({ token, expires_at });
                onChange({ target: { value: '' } });
                if (onCaptchaChange) {
                    onCaptchaChange({ value: '', token, expires_at });
                }
            }
        } catch (err) {
            console.error('Failed to load captcha:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadCaptcha();
    }, []);

    useEffect(() => {
        if (refreshTrigger > 0) loadCaptcha();
    }, [refreshTrigger]);

    const handleInputChange = (e) => {
        const val = e.target.value;
        onChange(e);
        if (onCaptchaChange) {
            onCaptchaChange({ value: val, token: captchaMeta.token, expires_at: captchaMeta.expires_at });
        }
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '8px 0' }}>
                {loading ? (
                    <div style={{
                        background: '#f3f4f6',
                        border: '2px solid #d1d5db',
                        borderRadius: '6px',
                        padding: '10px 20px',
                        minWidth: '130px',
                        textAlign: 'center',
                        color: '#9ca3af',
                        fontSize: '14px',
                    }}>
                        Loading...
                    </div>
                ) : (
                    <div style={{
                        background: '#f3f4f6',
                        border: '2px solid #d1d5db',
                        borderRadius: '6px',
                        padding: '10px 20px',
                        fontSize: '20px',
                        fontWeight: '700',
                        letterSpacing: '3px',
                        userSelect: 'none',
                        minWidth: '130px',
                        textAlign: 'center',
                        fontFamily: 'monospace',
                    }}>
                        {question} = ?
                    </div>
                )}
                <button
                    type="button"
                    onClick={loadCaptcha}
                    disabled={loading}
                    className="btn btn-danger"
                    title="New question"
                >↻</button>
            </div>
            <input
                type="number"
                value={value}
                onChange={handleInputChange}
                placeholder={placeholder}
                autoComplete="off"
                className={`form-control${error ? ' is-invalid' : ''}`}
            />
            {error && <div className="invalid-feedback" style={{ display: 'block' }}>{error}</div>}
            <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>Solve the math question above.</p>
        </div>
    );
};

export default CaptchaInput;
